//my-web-app/src/utils/api.ts

// utils/api.ts
// import { useEffect, useState } from 'react';
import axios from 'axios';
import { Brand, Category, Product, appConfig, Customer } from './types';
import { setAuthToken, removeAuthToken, hasRole, isAuthenticated } from './auth';
// import { getConfig } from '../config/configLoader';
import { AxiosResponse } from 'axios'; // Import AxiosResponse type
import { ApiCountry, ApiState, ApiCity } from './types'; // Ensure appConfig is imported



// Accessing the API URL from environment variables

// Type-safe access
const API_URL = window.APP_CONFIG?.API_URL || process.env.REACT_APP_API_URL;
const DOMAIN_URL = window.APP_CONFIG?.DOMAIN_URL || process.env.REACT_APP_DOMAIN_URL;

// const API_URL = process.env.REACT_APP_API_URL;
// const DOMAIN_URL = process.env.REACT_APP_DOMAIN_URL;
// console.log(API_URL);


// Create an axios instance with the base URL
export const api = axios.create({
    baseURL: API_URL,
});


// Add a response interceptor
api.interceptors.response.use(
    (response) => response, // Pass through successful responses
    (error) => {
        // Check for a 403 error
        if (error.response?.status === 403) {
            // Clear local storage and redirect to login
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            window.location.href = "/login"; // Force navigation
        } else if (error.response?.data?.message === "Token expired") {
            // Handle token expiration separately if needed
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            window.location.href = "/login"; // Force navigation
        }

        console.error('API Error:', error);
        return Promise.reject(error);
    }
);




export const checkSession = async () => {

    const user = JSON.parse(localStorage.getItem('user') || '{}');
    // console.log('App > useEffect > user.remember_token', user.remember_token);
    // console.log('App > useEffect > user.session_id', user.session_id);
    const sessionId = user.session_id; // Retrieve the session_id from local storage
    const token = user.remember_token;
    // console.table('user', user);


    try {
        // const response = await api.get('/check-session?session_id=' + sessionId, {
        //     headers: {
        //         'X-Session-ID': sessionId,
        //     },

        if (isAuthenticated() && hasRole(['super_admin', 'staff'])) {

            console.log('No need to checkSession');

        } else {
            const response = await api.get('/check-session', {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
                params: {
                    session_id: sessionId,
                },
            });

            // console.log('checkSession response', response);
            // console.log('csd');
            // console.log(hasRole(['super_admin', 'staff']), 'CS :', new Date().toLocaleString());

        }

    } catch (error) {
        console.error('Error checking session:', error);
    }
};

//my-web-app/src/utils/api.ts
export const appSettings = async (): Promise<appConfig> => {
    // api = await initializeApiClient();

    if (!api) {
        throw new Error('API client is not initialized. Please ensure it is initialized before calling appSettings.');
    }

    const response = await api.get('/settings?k=250507a');
    const settings = response.data;
    localStorage.setItem('settings', JSON.stringify(settings));

    // console.log('settings response > ', response);

    return settings;
};

// Register function for new users
// my-web-app/src/utils/api.ts

export const register = async (
    name: string,
    email: string,
    password: string,
    password_confirmation: string,
    phone: string = '', // Optional phone field
    customUrl: string, // Additional parameter
    companyName: string, // Additional parameter
) => {
    try {
        const response = await api.post('/register', {
            name,
            email,
            password,
            password_confirmation,
            phone, // Include phone in the payload
            customUrl: DOMAIN_URL, // Additional parameter
            companyName: 'KA Price' // Additional parameter
        });

        const token = response.data.access_token;

        if (token) {
            setAuthToken(token);
            localStorage.setItem('user', JSON.stringify(response.data.user));
        }

        return response;
    } catch (error) {
        console.error("Registration failed:", error);
        throw error;
    }
};


// Existing login function, modified to store user data in localStorage
export const login = async (email: string, password: string) => {
    const response = await api.post('/login', { email, password });
    const token = response.data.access_token;

    if (token) {
        setAuthToken(token);
        localStorage.setItem('user', JSON.stringify(response.data.user));
        localStorage.setItem('customer', JSON.stringify(response.data.customer_id));
    }

    console.log('login response > ', response);

    return response;
};

// utils/api.ts

export const sendResetLink = async (
    email: string,
    customUrl: string, // Additional parameter
    companyName: string, // Additional parameter
) => {
    const response = await api.post('/forgot-password', {
        email,
        customUrl, // Adjust as needed
        companyName, // Adjust as needed
    });
    return response;
};

export const resetPassword = async (email: string, password: string, confirmPassword: string, token: string) => {
    const response = await api.post('/reset-password', {
        email,
        password,
        password_confirmation: confirmPassword,
        token,
    });
    return response;
};


// Function to fetch user roles and permissions
export const fetchRolesPermissions = async () => {
    const token = localStorage.getItem('token'); // Get the stored token
    if (!token) throw new Error('No authentication token found');

    const response = await api.get('/roles-permissions', {
        headers: {
            Authorization: `Bearer ${token}`, // Include the token in the headers
        },
    });
    return response.data; // Ensure this matches the structure of your roles and permissions data
};

// --- NEW FUNCTION abb 250425 ---
/**
 * Fetches the roles associated with a specific user ID.
 * Requires authentication token.
 * @param userId The ID of the user whose roles are to be fetched.
 * @returns Promise resolving to the user's roles data.
 */
export const fetchRolesByUserId = async (userId: number) => {
    const token = localStorage.getItem('token'); // Get the stored token
    if (!token) {
        console.error('fetchRolesByUserId: No authentication token found.');
        throw new Error('No authentication token found');
    }

    try {
        // Construct the URL using the userId
        const url = `/users/${userId}/roles`;

        const response = await api.get(url, {
            headers: {
                Authorization: `Bearer ${token}`, // Include the token in the headers
            },
        });

        // console.log(`fetchRolesByUserId for user ${userId}:`, response.data); // Optional: for debugging
        return response.data; // Return the roles data from the response

    } catch (error) {
        console.error(`Error fetching roles for user ${userId}:`, error);
        // Re-throw the error so the calling component can handle it
        throw error;
    }
};
// --- END NEW FUNCTION ---

// Fetch categories using the axios instance
export const fetchCategories = async (): Promise<Category[]> => {
    const response = await api.get('/categories'); // Use the api instance here
    // console.log('Category > ', response.data);
    localStorage.setItem('categories', JSON.stringify(response.data)); // Store categories in local storage
    return response.data; // Ensure this matches the structure of your Category type
};

// /src/utils/api.ts


export const fetchBrands = async (): Promise<Brand[]> => {
    const response = await api.get('/brands');
    return response.data;
};


// Fetch products with pagination and sorting options
export const fetchProducts = async (
    currentPage: number,
    search: string,
    selectedCategory: number | null,
    selectedBrand: number | null,
    perPage: number,
    sort: string
) => {
    let url = `/products2?page=${currentPage}&perPage=${perPage}&search=${search}&sort=${sort}`;

    if (selectedCategory) {
        url += `&category_id=${selectedCategory}`;
    }
    if (selectedBrand) {
        url += `&brand_id=${selectedBrand}`;
    }

    // console.log(url);

    // Get the authentication token if the user is logged in
    const token = localStorage.getItem('token'); // Get the stored token

    // Create a config object to include the token in the headers
    const config = token
        ? {
            headers: {
                Authorization: `Bearer ${token}`, // Send the token in the Authorization header
            },

        }
        : {}; // If no token, don't send any extra headers

    const response = await api.get(url, config); // Use the api instance here
    // console.log(url, config);
    // console.log('fetchProducts in api.ts >>', response);
    // Calculate total_pages using 'total' and 'perPage'
    const totalPages = Math.ceil(response.data.total / perPage);
    const totalProdcts = response.data.total;

    // Extract the products
    const products = response.data.data.map((product: any) => ({
        ...product,
        MTPrice: product.MTPrice || null, // Add MTPrice if available, or default to null
    }));

    return {
        // products: response.data.data, // Assuming 'data' contains the array of products
        products, // Assuming 'data' contains the array of products
        total_pages: totalPages,      // Calculating the total number of pages
        total_products: totalProdcts,      // Calculating the total number of products
    };
};

// Function to fetch a product by its ID
export const fetchProductById = async (id: number): Promise<Product> => {

    // Get the authentication token if the user is logged in
    const token = localStorage.getItem('token'); // Get the stored token

    // Create a config object to include the token in the headers
    const config = token
        ? {
            headers: {
                Authorization: `Bearer ${token}`, // Send the token in the Authorization header
            },

        }
        : {}; // If no token, don't send any extra headers

    // const response = await api.get(url, config); // Use the api instance here
    const response = await api.get(`/product/${id}`, config); // Adjust the endpoint as necessary
    // console.log('api.ts > ', id, response);
    return response.data; // Ensure this matches the structure of your Product type
};

// Function to fetch mt_price for the logged-in dealer
// src/utils/api.ts

// export const fetchMtPrice = async (productId: number) => {
//     const token = localStorage.getItem('token'); // Get the stored token
//     const userId = JSON.parse(localStorage.getItem('user') || '{}').id; // Get user ID from local storage
//     const role = JSON.parse(localStorage.getItem('rolesPermissions') || '{}').roles[0]; // Assuming you want the first role

//     if (!token) throw new Error('No authentication token found');

//     const response = await api.get('/getmtprice', {
//         headers: {
//             Authorization: `Bearer ${token}`, // Include the token in the headers
//         },
//         params: {
//             user_id: userId,
//             role: role,
//             token: token,
//             product_id: productId, // Pass the product ID as a query parameter
//         },
//     });
//     // console.log(response);

//     return response.data; // Return the mt_price data
// };

// // src/utils/api.ts
// export const fetchMtPrices = async (productIds: number[]) => {
//     const token = localStorage.getItem('token');
//     if (!token) throw new Error('No authentication token found');

//     const response = await api.get('/getmtprices', {
//         headers: {
//             Authorization: `Bearer ${token}`,
//         },
//         params: {
//             product_ids: productIds.join(','), // Send multiple IDs as a comma-separated string
//         },
//     });

//     return response.data; // Adjust based on your API response structure
// };


// abb 250425



// Function to fetch mt_price for a specific user/role and product
export const fetchMtPrice = async (
    productId: number,
    targetUserId?: number, // Optional: ID of the user whose price we want
    targetUserRole?: string // Optional: Role of the user whose price we want
) => {
    const token = localStorage.getItem('token');
    if (!token) throw new Error('No authentication token found');

    // Determine user ID and role to use for the API call
    const userIdToUse = targetUserId ?? JSON.parse(localStorage.getItem('user') || '{}').id;
    // Ensure rolesPermissions is parsed safely and default if necessary
    let roleToUse = targetUserRole;
    if (!roleToUse) {
        try {
            const rolesPermissions = JSON.parse(localStorage.getItem('rolesPermissions') || '{}');
            roleToUse = rolesPermissions?.roles?.[0]; // Get the first role of the logged-in user
        } catch (e) {
            console.error("Failed to parse rolesPermissions from localStorage", e);
            roleToUse = undefined; // Or some default role if applicable
        }
    }


    if (!userIdToUse || !roleToUse) {
        console.error("fetchMtPrice: Missing User ID or Role for price calculation.");
        throw new Error("User ID or Role missing for price calculation.");
    }

    try {
        console.log('fetchMtPrice - userId:', userIdToUse, 'role:', roleToUse); // Debugging line
        const response = await api.get('/getmtprice', {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            params: {
                user_id: userIdToUse, // Use the determined user ID
                role: roleToUse,      // Use the determined role
                // token: token, // Token is usually sent in header, might be redundant here
                product_id: productId,
            },
        });
        // console.log(`fetchMtPrice for user ${userIdToUse}, role ${roleToUse}, product ${productId}:`, response.data);
        return response.data;
    } catch (error) {
        console.error(`Error in fetchMtPrice for user ${userIdToUse}, product ${productId}:`, error);
        throw error;
    }
};

// Function to fetch multiple mt_prices for a specific user/role and products
export const fetchAllMtPrices = async (
    productIds: number[],
    targetUserId?: number, // Optional: ID of the user whose prices we want
    targetUserRole?: string // Optional: Role of the user whose prices we want
) => {
    const token = localStorage.getItem('token');
    if (!token) throw new Error('No authentication token found');

    // Determine user ID and role to use
    const userIdToUse = targetUserId ?? JSON.parse(localStorage.getItem('user') || '{}').id;
    let roleToUse = targetUserRole;
    if (!roleToUse) {
        try {
            const rolesPermissions = JSON.parse(localStorage.getItem('rolesPermissions') || '{}');
            roleToUse = rolesPermissions?.roles?.[0];
        } catch (e) {
            console.error("Failed to parse rolesPermissions from localStorage", e);
            roleToUse = undefined;
        }
    }

    if (!userIdToUse || !roleToUse) {
        console.error("fetchAllMtPrices: Missing User ID or Role for price calculation.");
        throw new Error("User ID or Role missing for price calculation.");
    }

    if (productIds.length === 0) {
        return []; // Return empty if no product IDs provided
    }

    try {
        const response = await api.get('/allmtprices', { // Assuming this endpoint exists and works similarly
            headers: {
                Authorization: `Bearer ${token}`,
            },
            params: {
                user_id: userIdToUse,
                role: roleToUse,
                product_ids: productIds.join(','),
            },
        });
        // console.log(`fetchAllMtPrices for user ${userIdToUse}, role ${roleToUse}:`, response.data);
        // console.log('fetchAllMtPrices - userId:', userIdToUse, 'role:', roleToUse); // Debugging line

        return response.data;
    } catch (error) {
        console.error(`Error in fetchAllMtPrices for user ${userIdToUse}:`, error);
        throw error;
    }
};


// --- IMPORTANT ---
// Also review fetchProducts and fetchProductById. If your backend calculates and includes
// MTPrice directly in the response of these endpoints based on the authenticated user (via token),
// you might need to modify those backend endpoints AND these frontend API functions
// to accept and use targetUserId/targetUserRole similarly to fetchMtPrice.
// For now, we assume MTPrice is fetched separately or handled correctly by the backend based on the token.


// end abb 250425


// export const fetchAllMtPrices = async (productIds: number[]) => {
//     const token = localStorage.getItem('token');
//     if (!token) throw new Error('No authentication token found');

//     const response = await api.get('/allmtprices', {
//         headers: {
//             Authorization: `Bearer ${token}`,
//         },
//         params: {
//             product_ids: productIds.join(','), // Send multiple IDs as a comma-separated string
//         },
//     });

//     return response.data; // Adjust based on your API response structure
// };

export const uploadCsv = async (file: File) => {
    // const userId = JSON.parse(localStorage.getItem('user') || '{}').id; // Get user ID from local storage
    const role = JSON.parse(localStorage.getItem('rolesPermissions') || '{}').roles[0]; // Assuming you want the first role
    // console.log('roles' ,role);
    if (role !== 'super_admin' && role !== 'staff') {
        throw new Error('You do not have permission to upload CSV files.');
    }

    const formData = new FormData();
    formData.append('csv_file', file);

    const response = await axios.post('https://t1.u8.my/api/import-csv', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return response.data;
};




export const getOrderProcessLog = async (orderId: number) => {

    const token = localStorage.getItem('token'); // Get the stored token

    const response = await api.get(`/orders/${orderId}/process-log`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });


    // console.log('getOrderProcessLog:', response);

    return response.data; // Adjust based on the API response structure
};



export const fetchOrderDetails = async (orderId: number) => {

    const token = localStorage.getItem('token'); // Get the stored token


    const response = await api.get(`orders/${orderId}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });

    // console.log('fetchOrderDetails in api ln205:', response);

    // Map the response data to include modifiers
    const orderData = {
        ...response.data,
        items: response.data.items.map((item: any) => ({
            ...item,
            modifiers: item.modifiers || [], // Ensure modifiers is an array
        })),
    };

    // console.log('fetchOrderDetails in api ln 405:', orderData);

    return orderData;
};

// export const fetchOrderHistory = async (userId: number, status: string, page: number = 1, limit: number = 10, role: string) => {

//     const token = localStorage.getItem('token'); // Get the stored token
//     // console.log('fetchOrderHistory:', token,  status, page, limit);
//     // {hasRole(['super_admin', 'staff']) && (

//     const response = await api.get(`/orders/history`, {
//         headers: {
//             Authorization: `Bearer ${token}`,
//         },
//         params: {
//             user_id: userId, // Add userId to the request
//             status,
//             page,
//             limit,
//             role,
//         },
//     });

//     // console.log('fetchOrderHistory:', response, userData, token);

//     // Check if the response data is empty
//     // if (!response.data || response.data.length === 0) {
//     //     return 0;
//     // }

//     return response.data; // Adjust based on the API response structure
// };


export const fetchOrderHistory = async (
    userId: number,
    status: string,
    page: number = 1,
    limit: number = 10,
    role: string,
    search: string = '' // <-- Add search parameter with a default value
) => {
    const token = localStorage.getItem('token');
    if (!token) throw new Error('No authentication token found');

    const response = await api.get(`/orders/history`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
        params: {
            user_id: userId,
            status,
            page,
            limit,
            role,
            search, // <-- Include search in the API request parameters
        },
    });

    // console.log('fetchOrderHistory API call params:', { userId, status, page, limit, role, search }); // Optional: for debugging

    return response.data;
};

export const createOrder = async (payload: any) => {
    const token = localStorage.getItem('token'); // Get the stored token
    // const userId = JSON.parse(localStorage.getItem('user') || '{}').id; // Get user ID from local storage
    // const role = JSON.parse(localStorage.getItem('rolesPermissions') || '{}').roles; // Assuming you want the first role

    if (!token) throw new Error('No authentication token found');

    // const response = await api.get('/getmtprice', {


    const url = `${API_URL}/orders`;

    const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
    };


    try {
        const response = await api.post(url, payload, { headers });

        // console.log('api ln 364 createOrder:', { response, payload, token });

        // return response.data;
        return response;

    } catch (error) {
        console.error("Error creating order:", error);
        throw error;
    }

};


export const updateOrder = async (orderId: number, payload: any) => {
    const token = localStorage.getItem('token'); // Get the stored token


    const url = `${API_URL}/orders/update/${orderId}`;
    const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
    };

    return api.put(url, payload, { headers });
};

export const cancelOrder = async (orderId: number) => {

    const token = localStorage.getItem('token'); // Get the stored token


    const response = await api.put(`orders/status`,
        {
            orderId: orderId,
            status: 'cancel'
        },
        {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        }
    );

    return response.data; // Assuming the API returns a success message
};

export const deleteOrder = async (orderId: number) => {

    const token = localStorage.getItem('token'); // Get the stored token


    const response = await api.delete(`orders/delete`, {
        data: {
            orderId: orderId,
        },
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    });

    return response.data; // Assuming the API returns a success message
};

export const fetchAllCustomer = async () => {

    const token = localStorage.getItem('token'); // Get the stored token


    const response = await api.get(`customers/all-name-id`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        }
    );

    return response.data; // Assuming the API returns a success message
};


export const fetchProductsModifiers = async (
    pid: number, //product id
    add_on: number, //to list add_on products (modifier) that is product_cat = 2 (add-on)

) => {

    const token = localStorage.getItem('token'); // Get the stored token

    const url = `/products/modifiers?pid=${pid}&add_on=${add_on}`;

    const response = await api.post(url, {
        headers: {
            Authorization: `Bearer ${token}`, // Send the token in the Authorization header
        },
        // params: {
        //     pid,
        //     add_on,
        // },
    });

    // console.log('fetchProductsModifiers apip ln 501 :', response);

    return response;
};

// --- Add function to download Order PDF ---
export const downloadOrderPdf = async (orderId: number): Promise<Blob> => {
    const token = localStorage.getItem('token');
    if (!token) {
        throw new Error('No authentication token found');
    }

    try {
        const response: AxiosResponse<Blob> = await api.get(`/orders/${orderId}/pdf`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            responseType: 'blob', // Important: Expect a binary response (the PDF file)
        });

        // Check if the response is actually a blob (PDF)
        if (response.data instanceof Blob && response.data.type === 'application/pdf') {
            return response.data;
        } else {
            // If the server sent an error (e.g., JSON), it might end up here
            // Try to parse it if it's JSON, otherwise throw a generic error
            if (response.data instanceof Blob && response.data.type === 'application/json') {
                const errorText = await response.data.text();
                const errorJson = JSON.parse(errorText);
                throw new Error(errorJson.message || 'Received unexpected response format instead of PDF.');
            }
            throw new Error('Received unexpected response format instead of PDF.');
        }
    } catch (error: any) {
        console.error(`Error downloading PDF for order ${orderId}:`, error);
        // Re-throw the error so the component can handle it (e.g., show toast)
        // Include response details if available
        if (error.response) {
            throw { ...error, response: error.response }; // Keep response details
        }
        throw error;
    }
};
// --- End PDF Download function ---


// --- Add function to send WhatsApp message via Venom Bot ---
/**
 * Sends a WhatsApp message using the venom-bot service.
 * @param phoneNumber The recipient's phone number (e.g., '601112163808').
 * @param message The text message to send.
 * @returns Promise resolving to the response from the venom-bot service.
 */
// Define an interface for the expected response (optional but good practice)
interface VenomBotResponse {
    status: string; // Or whatever structure your API returns
    message?: string;
    // ... other potential fields
}

export const sendWhatsAppMessage = async (phoneNumber: string, message: string): Promise<VenomBotResponse> => {
    // Define the URL of your venom-bot service endpoint
    const venomBotUrl = 'https://wa.u8.my/send-message'; // Consider making this configurable

    // Format the phone number as required by venom-bot
    const formattedPhoneNumber = `${phoneNumber}`;

    try {
        console.log(`Sending WhatsApp to ${formattedPhoneNumber}: "${message}"`);

        // Make a POST request to your venom-bot service
        const response = await axios.post<VenomBotResponse>(venomBotUrl, { // Specify expected response type
            // Use the key expected by the API (e.g., 'number') and the formatted value
            phone: formattedPhoneNumber,
            message: message,
            // Add authentication if required by the venom-bot service
            // headers: { 'X-API-Key': 'YOUR_VENOM_BOT_API_KEY' }
        });

        // console.log('WhatsApp send response:', response.data);
        return response.data;

    } catch (error: any) {
        const errorMessage = error.response?.data?.message || error.message || 'An unknown error occurred';
        console.error(`Error sending WhatsApp message to ${phoneNumber} (formatted as ${formattedPhoneNumber}):`, errorMessage, error.response?.data);
        // Re-throw a more informative error
        throw new Error(`Failed to send WhatsApp message: ${errorMessage}`);
    }
};
// --- End WhatsApp send function ---


// --- Add function to trigger sending order email ---
/**
 * Sends a request to the backend to email the order details.
 * @param orderId The ID of the order to email.
 * @param recipientEmail Optional: Specify a recipient email. If not provided, the backend might use the customer's email on the order.
 * @returns Promise resolving to the response from the backend API.
 */
export const sendOrderEmail = async (orderId: number, recipientEmail?: string): Promise<any> => {
    const token = localStorage.getItem('token');
    if (!token) {
        throw new Error('No authentication token found');
    }

    // Define the backend endpoint for sending the email
    const emailEndpoint = `/orders/${orderId}/email`; // Adjust if your endpoint is different

    try {
        console.log(`Requesting email for order ${orderId}` + (recipientEmail ? ` to ${recipientEmail}` : ''));

        // Make a POST request (or GET/PUT depending on your API design)
        // Pass recipientEmail in the body if needed by the backend
        const response = await api.post(emailEndpoint,
            {
                email: recipientEmail // Send email in the body if needed
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        // console.log('Send email response:', response.data);
        return response.data; // Return the success/status message from the backend

    } catch (error: any) {
        const errorMessage = error.response?.data?.message || error.message || 'An unknown error occurred';
        console.error(`Error requesting email for order ${orderId}:`, errorMessage, error.response?.data);
        throw new Error(`Failed to send order email: ${errorMessage}`);
    }
};
// --- End send order email function ---

/**
 * Updates a specific field for a customer.
 * @param customerId - The ID of the customer to update.
 * @param field - The specific field (key) of the customer object to update.
 * @param value - The new value for the field.
 * @returns The updated customer data from the API.
 */
export const updateCustomer = async (
    customerId: string,
    field: keyof Customer,
    value: string
) => {
    const token = localStorage.getItem('token'); // Get the stored token
    if (!token) {
        console.error('Authentication token not found for updateCustomer.');
        throw new Error('Authentication required.'); // Or handle as appropriate
    }

    // Construct the payload dynamically: { fieldName: newValue }
    const payload = { [field]: value };
    // Use the relative path, as the 'api' instance should have the base URL configured
    const url = `/customers/${customerId}`;

    try {
        // console.log(`Attempting PATCH ${url} with payload:`, payload);
        const response = await api.patch(url, payload, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        // console.log(`Customer ${customerId} field ${String(field)} updated successfully:`, response.data);
        return response.data; // Return the updated data from the backend
    } catch (error: any) {
        // Log more specific error details if available
        const errorDetails = error.response?.data || error.message || error;
        console.error(`Error updating customer ${customerId} field ${String(field)}:`, errorDetails);
        // Re-throw the error so the calling component can handle it (e.g., show an alert)
        throw error;
    }
};

// --- Caching ---
let cachedLocations: ApiCountry[] | null = null;
// Use Maps for caching states/cities by their parent ID
const cachedStates = new Map<string | number, ApiState[]>();
const cachedCities = new Map<string | number, ApiCity[]>();
// --- End Caching ---

// Fetches only the list of countries
export const fetchLocations = async (): Promise<ApiCountry[]> => {
    if (cachedLocations !== null && cachedLocations.length > 0) {
        console.log('Returning cached locations (countries)');
        return cachedLocations;
    }
    try {
        const response = await api.get('/v1/countries');
        if (response.status !== 200) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const countriesData: ApiCountry[] = response.data;
        if (!Array.isArray(countriesData)) {
            throw new Error("Invalid data format received from API for countries.");
        }
        cachedLocations = countriesData;
        // console.log('Fetched and cached locations (countries)', cachedLocations);

        return cachedLocations;
    } catch (error) {
        console.error("Failed to fetch locations (countries):", error);
        throw error;
    }
};

// Fetches states for a specific country ID
export const fetchStatesForCountry = async (countryId: string | number): Promise<ApiState[]> => {
    if (cachedStates.has(countryId)) {
        console.log(`Returning cached states for country ${countryId}`);
        return cachedStates.get(countryId)!; // Use non-null assertion as we checked with .has()
    }
    try {
        // Use the correct endpoint based on your API routes
        const response = await api.get(`/v1/countries/${countryId}/states`);
        if (response.status !== 200) {
            throw new Error(`HTTP error fetching states! status: ${response.status}`);
        }
        const statesData: ApiState[] = response.data; // Assuming the endpoint returns the array directly
        if (!Array.isArray(statesData)) {
            throw new Error("Invalid data format received from API for states.");
        }
        cachedStates.set(countryId, statesData); // Cache the fetched states
        // console.log(`Fetched and cached states for country ${countryId}`, statesData);
        return statesData;
    } catch (error) {
        console.error(`Failed to fetch states for country ${countryId}:`, error);
        throw error;
    }
};

// Fetches cities for a specific state ID
export const fetchCitiesForState = async (stateId: string | number): Promise<ApiCity[]> => {
    if (cachedCities.has(stateId)) {
        console.log(`Returning cached cities for state ${stateId}`);
        return cachedCities.get(stateId)!; // Use non-null assertion
    }
    try {
        // Use the correct endpoint based on your API routes
        const response = await api.get(`/v1/states/${stateId}/cities`);
        if (response.status !== 200) {
            throw new Error(`HTTP error fetching cities! status: ${response.status}`);
        }
        const citiesData: ApiCity[] = response.data; // Assuming the endpoint returns the array directly
        if (!Array.isArray(citiesData)) {
            throw new Error("Invalid data format received from API for cities.");
        }
        cachedCities.set(stateId, citiesData); // Cache the fetched cities
        // console.log(`Fetched and cached cities for state ${stateId}`, citiesData);
        return citiesData;
    } catch (error) {
        console.error(`Failed to fetch cities for state ${stateId}:`, error);
        throw error;
    }
};

// Assuming an endpoint like /customers/{id} exists
export const fetchCustomer = async (customerId: number): Promise<Customer> => {
    const token = localStorage.getItem('token');
    if (!token) throw new Error('Authentication required.');

    // Adjust URL based on your API structure
    const url = `/customers/${customerId}`;

    try {
        const response = await api.get(url, {
            headers: { Authorization: `Bearer ${token}` },
        });
        if (!response.data) { // Add check if response might be empty for not found
            throw new Error(`Customer with ID ${customerId} not found.`);
        }
        // Assuming the API returns the customer object directly
        return response.data as Customer;
    } catch (error: any) {
        console.error(`Failed to fetch customer ${customerId}:`, error.response?.data || error.message);
        throw error;
    }
};